import type { FunctionComponent } from "react"

import { NewsFeedWrapper } from "@/modules/companies/client/components/NewsFeedWrapper/NewsFeedWrapper"

export const Newsfeed: FunctionComponent = () => (
  <div data-testid="company_news_feed">
    <NewsFeedWrapper />
  </div>
)
